import { getTenantClient } from '@sazeo/supabase-tenant';

export const TENANT_LOGO_BUCKET = 'tenant-logos';
export const TENANT_LOGO_MAX_BYTES = 2 * 1024 * 1024;

export function resolveTenantLogoUrl(storageKey: string | null | undefined): string | null {
  if (!storageKey) return null;
  const { data } = getTenantClient().storage.from(TENANT_LOGO_BUCKET).getPublicUrl(storageKey);
  return data.publicUrl;
}

export function inferTenantLogoExt(file: Pick<File, 'name' | 'type'>): 'png' | 'svg' | null {
  const type = file.type.toLowerCase();
  const name = file.name.toLowerCase();

  if (type === 'image/svg+xml' || name.endsWith('.svg')) return 'svg';
  if (type === 'image/png' || name.endsWith('.png')) return 'png';
  return null;
}
